import { useContext, useEffect, useState } from "react";
import { Table, Card } from "antd";

import { Context } from "../../context";
import { Fetch } from "../../fetch";

import "./styles.css";

const { Column } = Table;

const FunnelMetrics = () => {
  const { token, apiUrl } = useContext(Context);
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [lastMonths, _] = useState(6);

  useEffect(() => {
    setLoading(true);
    Fetch(
      `${apiUrl}/reports/funnel_reports?last=${lastMonths}`,
      token,
      (result) => {
        if (result) {
          setColumns(result.columns);
          setData(result.data);
          setLoading(false);
          setRefresh(false);
        } else {
          setLoading(false);
          setRefresh(false);
        }
      }
    );
  }, [apiUrl, token, refresh]);

  return (
    <Card className="reports-wrapper" title={`Funnel Metrics`}>
      {(columns && columns.length === 0) || (data && data.length) === 0 ? (
        <div>Data unavailable at this moment, please try after sometime.</div>
      ) : (
        <Table
          dataSource={data}
          size="small"
          bordered={true}
          pagination={false}
          style={{ border: "3px", background: "white" }}
          loading={loading}
        >
          {columns &&
            columns.map((mo) => (
              <Column
                title={
                  mo.name
                    ? `${mo.name.split("::")[0].substring(0, 3)} (${mo.name
                        .split("::")
                        .pop()})`
                    : "Metrics"
                }
                dataIndex={mo.dataIndex}
                key={mo.name ? mo.name : "metrics"}
                align={mo.align}
                width={!mo.name && "10%"}
              />
            ))}
        </Table>
      )}
    </Card>
  );
};

export default FunnelMetrics;
